export default __webpack_public_path__ + "static/media/reformcloud_vertical.a4837c61.png";